import { render, staticRenderFns } from "./CarrierEdit.vue?vue&type=template&id=0a464f13&"
import script from "./CarrierEdit.vue?vue&type=script&lang=js&"
export * from "./CarrierEdit.vue?vue&type=script&lang=js&"
import style0 from "./CarrierEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports